import React, { forwardRef } from "react";

import { Dropdown, DropdownComponent } from "./dropdown.jsx";
import { DropdownItem } from "./dropdown.renderers.js";

export function SingleSelectDropdownComponent(props, ref) {
  return <Dropdown {...props} ref={ref} />;
}

SingleSelectDropdownComponent.propTypes = {
  ...DropdownComponent.propTypes
};

export const SingleSelectDropdown = forwardRef(SingleSelectDropdownComponent);

// eslint-disable-next-line kf/const-naming-convention
export const SingleSelectDropdownItem = DropdownItem;

export {
  DROPDOWN_SIZES,
  DROPDOWN_POSITION,
  DROPDOWN_TYPE,
  DROPDOWN_CHIP_SIZE_MAPPING,
  GROUP_TYPE
} from "./constants.js";
